import { render, staticRenderFns } from "./SelectSpace.vue?vue&type=template&id=ad4264d2"
import script from "./SelectSpace.vue?vue&type=script&lang=js"
export * from "./SelectSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports